import Formatter from '../../../classes/Formatter';

export interface IFormattedDocumentNumber {
  documentNumber: string;
}

export const FormattedDocumentNumber = (props: IFormattedDocumentNumber) => {
  return <>{Formatter.formatCPF_CNPJ(props.documentNumber)}</>;
};
